module.exports = __webpack_public_path__ + "20-o2.gif?a2ada0f9001e40faaf6b9ae97ac96223";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/20-o2.gif
// module id = 641
// module chunks = 0